import { createSlice } from "@reduxjs/toolkit";
import { getUser, addNote, updateUser, deleteUser, initialClinic } from "../../api/APIServices";
import { API_STATUS } from "../../constants";

    const initialState = {
        status:API_STATUS.IDEL,
        noteStatus:API_STATUS.IDEL, 
        data:{},
        compliance:{},
        notes:[],
        isUserDeleted:false,
        intakeCheckList:false
    };
    
    const userSlice = createSlice({
        name:'user',
        initialState,
        reducers:{
            resetUser(state){
                state.status=API_STATUS.IDEL, 
                state.noteStatus=API_STATUS.IDEL, 
                state.data={},
                state.compliance={},
                state.notes=[]
            },
            resetUserDeletedFlag(state, action){
                state.isUserDeleted = action.payload;
            }
        },
        extraReducers:(builder)=>{
            //getUser
            builder.addCase(getUser.fulfilled, (state, action)=> {
                state.data = action.payload.user;
                state.compliance =  action.payload.compliance;
                state.notes =  action.payload.notes;
                state.status = API_STATUS.SUCCESS;
                state.noteStatus = API_STATUS.SUCCESS;
            }),
            builder.addCase(getUser.pending, (state)=> {
                state.status = API_STATUS.PENDING;
                state.noteStatus = API_STATUS.PENDING;
            }),
            builder.addCase(getUser.rejected, (state)=> {
                state.status = API_STATUS.ERROR;
            }),

        
        //updateUser
        builder.addCase(updateUser.fulfilled, (state, action)=>{
            state.data = action.payload;
            state.status = API_STATUS.SUCCESS;
        }),
        builder.addCase(updateUser.pending, (state)=>{
            state.status = API_STATUS.PENDING;
        }),
        builder.addCase(updateUser.rejected, (state)=>{
            state.status = API_STATUS.ERROR;
        })

        //delete User
        builder.addCase(deleteUser.fulfilled, (state, action)=> {
            state.status = API_STATUS.SUCCESS;
            state.isUserDeleted = true 
        }),
        builder.addCase(deleteUser.pending, (state)=>{
            state.status = API_STATUS.PENDING;
        }),
        builder.addCase(deleteUser.rejected, (state)=>{
            state.status = API_STATUS.ERROR;
        })
        
        
        //addNote
        builder.addCase(addNote.fulfilled, (state, action)=>{
            state.notes.push(action.payload);
            state.noteStatus = API_STATUS.SUCCESS;           
        }),
        builder.addCase(addNote.pending, (state)=>{
            state.noteStatus = API_STATUS.PENDING;
        }),
        builder.addCase(addNote.rejected, (state)=>{
            state.noteStatus = API_STATUS.ERROR;
        })

        //user/clinic
        builder.addCase(initialClinic.fulfilled, (state, action)=>{
            state.data = action.payload.user;
            state.clinicalData = action.payload.clinicalData
            state.intakeCheckList = true,
            state.status = API_STATUS.IDEL;
        }),
        builder.addCase(initialClinic.pending, (state)=>{
            state.status = API_STATUS.PENDING;
        }),
        builder.addCase(initialClinic.rejected, (state)=>{
            state.status = API_STATUS.ERROR;
        })

    }
});

export const {resetUser, resetUserDeletedFlag
} = userSlice.actions;
export default userSlice.reducer;